import { Bar } from "./components/bar.container";
import { ProgressBarButton } from "./components/button";
import { Base } from "./progressBar.base";

export const ProgressBar = Object.assign(Base, {
    Bar: Bar,
    Button: ProgressBarButton
});
